module.exports = __webpack_public_path__ + "img/salary.b88420e6.png";